// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mmWT","delete":"styles_delete__14c-x","update":"styles_update__2c3f1","add":"styles_add__iElgF"};